// extracted by mini-css-extract-plugin
export default {"input":"TreatmentModal_input__eXC8V"};